<template>
    <div class="con">
        <banComponent :img="info.img" :text0="info.text0" :text1="info.text1"></banComponent>
        <div class="nav">
            <span v-for="(item,index) in navList" :key="index" :class="{'showLine':select===index}" @click="change(index)">{{item}}</span>
        </div>
       <div class="main wow fadeInUp">
           <p class="title wow fadeInUp">{{text}}</p>
           <div class="allItem wow fadeInUp">
               <div class="item" v-for="(item,index) in newsList" :key="index">
                   <router-link :to="{path: 'newsInfo',query:{id:item.ID}}" target="_blank">
                       <div class="run">
                           <p>{{item.TITLE}}</p>
                           <p>{{item.SHOWTIME}}</p>
                           <p>{{item.CON}}</p>
                           <img :src="`http://junankg.com/upload/${item.SMALLPIC}`" alt="">
                       </div>
                   </router-link>
               </div>
           </div>
           <div style="text-align: center;margin-top: 60px;" @click="showMore">
               <span>{{$t('about').text2}}</span>
               <btn-Component></btn-Component>
           </div>
       </div>
        <foot-Component></foot-Component>
    </div>
</template>

<script>
    import  banComponent from '../components/tbanner'
    import btnComponent from '../components/btn'
    import footComponent from '../components/foot'
    import { getNewsUrl} from '../util/lang'
    export default {
        name: "news",
        data(){
            return{
                id:'',
                page:'',
                totalPage:'',
                select:0,
                text:'',
                navList:[],
                info:{
                    img:require('../assets/news/ban.png'),
                    text0:'君安资讯',
                    text1:'君安与您共享精彩，期待您的关注和参与'
                },
                newsList:[]
            }
        },
        components:{banComponent,footComponent,btnComponent},
        mounted(){
            if(this.$route.query.index!==undefined){
                this.change(parseInt(this.$route.query.index-1))
            }
            this.navList=this.$t('news').navList
            this.text=this.navList[0]
            if( this.$i18n.locale === 'en'){
                this.getNews('33')
                this.info={
                    img:require('../assets/news/ban.png'),
                    text0:'JUNAN NEWS',
                    text1:'Junan shares wonderful with you and looks forward to your attention and participation.'
                }
            }else{
                this.getNews('26')
            }
        },
        methods:{
            showMore(){
                if(this.page<=this.totalPage){
                    this.$nextTick(()=>{
                        const url = `${getNewsUrl(this.$i18n.locale,this.id,6,this.page++)}`
                        this.$axios.get(url).then(res => {
                            res.data.newsArr.map((item)=>{
                                item.SHOWTIME=item.SHOWTIME.slice(0,11)
                            })
                                this.newsList= this.newsList.concat(res.data.newsArr)
                        })

                    })
                }else{
                    this.$notify({
                        title: '提示',
                        message: '已经加载全部了',
                        offset: 100
                    });
                }
            },
            change(n){
                this.select=n
                this.text=this.navList[n]
                if(n===0){
                    if( this.$i18n.locale === 'en'){
                        this.getNews('33')
                    }else{
                        this.getNews('26')
                    }
                }else{
                    if( this.$i18n.locale === 'en'){
                        this.getNews('34')
                    }else{
                        this.getNews('27')
                    }
                }
            },
            getNews(id){
                this.page=2
                this.id=id
                const url = `${getNewsUrl(this.$i18n.locale,id,6,1)}`
                this.$axios.get(url).then(res => {
                    res.data.newsArr.map((item)=>{
                        item.SHOWTIME=item.SHOWTIME.slice(0,11)
                    })
                        this.newsList=res.data.newsArr
                    this.totalPage=res.data.pagerShow.totalPagers
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.con{
    width:100%;
    .nav{
        width:100%;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        justify-content:center;
        padding: 1px 0;
        border-bottom: 1px solid rgba(0,0,0,.2);
        span{
            display: inline-block;
            padding: 15px 80px;
            cursor: pointer;
            transition: all 2s;
            font-size: 15px;
        }
        span:hover{
            background-color: #0068B7;
            color:white;
        }
        .showLine{
            background-color: #0068B7;
            color:white;
        }
    }
    .main{
        width:1280px;
        margin: 0 auto;
        padding-bottom: 60px;
        .title{
            width:60%;
            color:#444546;
            font-size: 30px;
            font-weight: bold;
            border-bottom: 1px solid rgba(130, 130, 130, .3);
            padding-bottom: 20px;
            position: relative;
            text-align: center;
            margin: 80px 20%;
        }
        .title::before{
            position: absolute;
            left:35%;
            bottom:0;
            content:'';
            display: inline-block;
            width:30%;
            height:1px;
            background-color: #0068B7;
        }
        .allItem{
            width:100%;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            .item{
                width:28%;
                margin-left: 2%;
                overflow: hidden;
                background-color: white;
                margin-top: 60px;
                cursor: pointer;
                padding: 40px 10px;
                transition: all 0.6s ;
                .run{
                    transition: all 0.6s ;
                    margin-top: -40px;
                    img{
                    width:100%;
                    object-fit: cover;
                }
                    p:nth-child(1){
                        font-weight: bold;
                        font-size: 18px;
                        height:90px;
                        line-height: 30px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 3;
                        overflow: hidden;
                    }
                    p:nth-child(2){
                        font-size: 14px;
                        padding-top: 10px;
                    }
                    p:nth-child(3){
                        font-size: 14px;
                        line-height: 34px;
                        padding: 10px 0;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                    }

                }
            }
            a{
                color:black;
            }
            .item:hover{
                box-shadow: 0px 10px 60px rgba(0, 0, 0, 0.20);
                .run{
                    transform: translateY(40px);
                }
            }
        }
    }
    @media screen and (max-width:1279px){
        .nav{
            span{
                width:50%;
                padding: 15px 0;
                text-align: center;
            }
        }
        .main{
            width:95%;
            margin-left: 2.5%;
           .title{
               font-size: 20px;
               margin-top: 30px;
               margin-bottom: 20px;
           }
            .allItem{
                .item{
                    width:100%;
                }
            }
        }
    }
}
</style>